/**
 * Helper to determine if an error returned from backend / Callable function
 * is due to GitHub service being temporarily unavailable (HTTP 503).
 */
export function isGitHubUnavailableError(error: unknown): boolean {
	if (!error) return false;
	const err = error as {
		code?: string;
		message?: string;
		details?: { code?: string; status?: number; service?: string };
	};

	if (
		err.code === "functions/unavailable" ||
		err.code === "unavailable" ||
		err.details?.code === "GITHUB_UNAVAILABLE" ||
		err.details?.status === 503
	) {
		return true;
	}

	const message = String(err.message || error);
	const lower = message.toLowerCase();
	return (
		(message.includes("503") ||
			lower.includes("no server is currently available")) &&
		(lower.includes("github") ||
			lower.includes("pr creation failed") ||
			lower.includes("unavailable"))
	);
}
